import React from "react";

const NailColorProcess = () => {
  return (
    <div className="nailExtensionHeading">
      <h4>The Process of Nails Color Change in Bangalore at SCENT</h4>
      <p>
        Getting a nails color change in Bangalore at SCENT is a delightful
        experience. Here’s a step-by-step overview of what you can expect during
        your visit:
      </p>
      <ul>
        <li>
          <h6>1. Consultation:</h6> Our technicians will begin with a
          consultation to understand your preferences and style. Whether you
          have a specific color in mind or need some inspiration, we are here to
          help.
        </li>
        <li>
          <h6>2. Nail Preparation:</h6> Your nails will be thoroughly
          cleaned and prepped. This includes trimming, filing, and buffing to
          ensure a smooth surface for the application.
        </li>
        <li>
          <h6>3. Color Application:</h6> Based on your choice, our
          technicians will apply the nail color meticulously. For those opting
          for gel polish, the nails will be cured under a UV or LED lamp for a
          long-lasting finish.
        </li>
        <li>
          <h6>4. Finishing Touches:</h6> Once the color is applied, we will
          add any finishing touches, such as a top coat or nail art, to enhance
          the look.
        </li>
        <li>
          <h6>5. Aftercare Advice:</h6> Our technicians will provide you
          with tips on how to maintain your nails and make the color last
          longer. Regular care and touch-ups can keep your nails looking
          fabulous.
        </li>
      </ul>
    </div>
  );
};

export default NailColorProcess;
